<template>
  <div>
    <navbar :display-login="false" />

    <section>
      <h4>ΕΝΗΜΕΡΩΣΗ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ</h4>
      <h6>
        Είμαστε όλοι μία ομάδα και η ιδιωτικότητά σου είναι πολύ σημαντική για
        εμάς!
        <br />
        Αφιέρωσε λίγο χρόνο για να μάθεις πώς επεξεργαζόμαστε τα δεδομένα σου
      </h6>
      <div class="privacy-container">
        <div class="bussiness-specs">
          <p class="p-align mt-3">
            Στην SLM θέλουμε οι αποστολείς και οι παραλήπτες των ταχυδρομικών
            αντικειμένων, να γνωρίζουν και να έχουν έλεγχο στο ποια δεδομένα
            τους μοιράζονται μαζί μας και στο τι κάνουμε εμείς με αυτά. Το
            κείμενο αυτό (που ονομάζεται Πολιτική Απορρήτου) εξηγεί με απλά
            λόγια αλλά και σαφήνεια τι δεδομένα συλλέγουμε για εσάς στο πλαίσιο
            λειτουργίας των υπηρεσιών μας και πώς τα χρησιμοποιούμε, σύμφωνα με
            το περιεχόμενο του Κανονισμού (ΕΕ) 2016/679, όπως επίσης των
            Ν.4624/2019 και Ν.2472/1997.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>ΕΙΣΑΓΩΓΗ</h5>
          <p class="p-align mt-3">
            Η εταιρία με την επωνυμία «ΣΚΡΟΥΤΖ ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΜΟΝΟΠΡΟΣΩΠΗ
            ΙΔΙΩΤΙΚΗ ΚΕΦΑΛΑΙΟΥΧΙΚΗ ΕΤΑΙΡΕΙΑ» και έδρα στην οδό Αγίας Άννης 7,
            Αθήνα 118 55 (εφεξής η «SLM») και η συνδεδεμένη με αυτήν εταιρία με
            την επωνυμία «SKR STAFFING SERVICES ΜΟΝΟΠΡΟΣΩΠΗ ΙΔΙΩΤΙΚΗ
            ΚΕΦΑΛΑΙΟΥΧΙΚΗ ΕΤΑΙΡΙΑ» (εφεξής «SKR Staffing»), με έδρα στην οδό
            Πειραιώς 167, Αθήνα 118 53 (εφεξής από κοινού οι «Εταιρίες»), είναι
            κατά την ισχύουσα νομοθεσία από κοινού υπεύθυνες επεξεργασίας των
            προσωπικών σου δεδομένων στο πλαίσιο της εργασιακής σου σχέσης ως
            οδηγού ταχυδρομικών υπηρεσιών, με μία από αυτές (εφεξής η «Σχέση»).
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>ΠΡΟΣΩΠΙΚΑ ΔΕΔΟΜΕΝΑ ΠΟΥ ΣΥΛΛΕΓΟΥΜΕ</h5>
          <div class="p-align mt-3">
            Στο πλαίσιο της Σχέσης, οι Εταιρίες συλλέγουν και επεξεργάζονται
            περαιτέρω –κατά περίπτωση- τα ακόλουθα προσωπικά σου δεδομένα:
            <ul>
              <li>
                Ονοματεπώνυμο και λοιπά στοιχεία ταυτοποίησης (π.χ. πατρώνυμο,
                μητρώνυμο, ημερομηνία γέννησης, αριθμός ΑΔΤ / Διαβατηρίου, άδεια
                παραμονής), όπως αυτά προκύπτουν –μεταξύ άλλων- από την
                αστυνομική σου ταυτότητα
              </li>
              <li>
                Πληροφορίες που αφορούν στην οικογενειακή σου κατάσταση, καθώς
                και τυχόν στρατιωτική θητεία
              </li>
              <li>
                Στοιχεία προηγούμενης επαγγελματικής σου απασχόλησης, καθώς και
                εκπαίδευσης
              </li>
              <li>Στοιχεία άδειας οδήγησης</li>
              <li>
                Προσωπικά και εταιρικά στοιχεία επικοινωνίας, όπως διεύθυνση
                κατοικίας, τηλέφωνο σταθερό και κινητό, email, καθώς και
                στοιχεία έκτακτης επικοινωνίας με κοντινά σου πρόσωπα
              </li>
              <li>
                Πληροφορίες που αφορούν στην εργασιακή σου θέση, όπως μισθός και
                λοιπές παροχές/αποζημιώσεις, είδος σύμβασης, διάρκεια, ωράριο
                εργασίας, καταβαλλόμενες εισφορές, υπερωριακή απασχόληση,
                username
              </li>
              <li>
                Στοιχεία που συνδέονται με τη χρήση των πληροφοριακών συστημάτων
                των Εταιριών, όπως logs που περιλαμβάνουν τη διεύθυνση ΙΡ,
                timestamp, URL, εκτέλεση εντολών, εσωτερικός κωδικός για
                κατάθεση χρημάτων αντικαταβολών στο αυτόματο μηχάνημα, πρόσβαση
                στον τοπικό δίσκο και στο λογαριασμό ηλεκτρονικής αλληλογραφίας,
                στοιχεία εσωτερικών και εξωτερικών επικοινωνιών, αριθμός κάρτας
                πρόσβασης και timestamp εισόδου σου στις εγκαταστάσεις της SLM
              </li>
              <li>
                Στοιχεία τραπεζικού λογαριασμού σου, όπως ΙΒΑΝ, ονοματεπώνυμο
                δικαιούχου και της τυχόν prepaid κάρτας σου που εκδίδεται ως
                μορφή επιβράβευσης, όπως αριθμός κάρτας
              </li>
              <li>
                Πληροφορίες απαραίτητες για φορολογικούς και ασφαλιστικούς
                σκοπούς, όπως ΑΦΜ, ΔΟΥ, ΑΜΑ, ΑΜΚΑ
              </li>
              <li>
                Πληροφορίες που αφορούν στην αιτιολόγηση των αιτούμενων αδειών,
                συμπεριλαμβανομένης της κατάστασης υγείας σου, όπως αυτή
                προκύπτει από τυχόν ιατρικές γνωματεύσεις που μας προσκομίζεις
              </li>
              <li>
                Την εικόνα σου, είτε για σκοπούς εσωτερικής ή/και εξωτερικής
                επικοινωνίας, είτε στο πλαίσιο λειτουργίας κλειστού κυκλώματος
                CCTV στους χώρους των εισόδων και του εξωτερικού του κτιρίου της
                SLM
              </li>
              <li>
                Πληροφορίες που αφορούν στην εμπειρία σου στις Εταιρίες μας
              </li>
              <li>
                Πληροφορίες που σχετίζονται με την αξιολόγησή σου, όπως το
                σύνολο των παραδόσεων που εκπλήρωσες σε συνάρτηση με τον χρόνο
                που χρειάστηκες και τυχόν λοιπές παρατηρήσεις για την απόδοσή
                σου
              </li>
              <li>
                Πληροφορίες που αφορούν σε πιθανά ατυχήματα κατά την εργασία
                σου, όπως ο αριθμός κυκλοφορίας του οχήματος και οι πινακίδες
                του οχήματος, καθώς και τα περιστατικά γύρω από το ατύχημα
              </li>
              <li>
                Πληροφορίες που αφορούν στην εν γένει αξιολόγηση της υγείας σου,
                από τον γιατρό εργασίας
              </li>
              <li>Υπογραφή</li>
            </ul>
          </div>
        </div>
        <div class="bussiness-specs">
          <h5>ΓΙΑΤΙ ΤΑ ΣΥΛΛΕΓΟΥΜΕ</h5>
          <div class="bussiness-specs">
            <span><u>A. Σύμβαση</u></span>
            <p class="p-align mt-3">
              Οι Εταιρίες επεξεργάζονται τα δεδομένα σου στο πλαίσιο ολοκλήρωσης
              της πρόσληψής σου, αλλά και της γενικότερης εκπλήρωσης των
              δικαιωμάτων και υποχρεώσεων που απορρέουν από τη συμβατική Σχέση
              σου, όπως ενδεικτικά για τη διαχείριση αδειών, μισθοδοσίας και
              λοιπών παροχών κι εξόδων, καθώς και για τη συμμετοχή σου σε
              εκπαιδεύσεις. Στο πλαίσιο αυτό και ανάλογα με τη θέση απασχόλησής
              σου, γίνονται αντικείμενο επεξεργασίας από τις Εταιρίες επίσης
              δεδομένα που δημιουργείς κατά τη χρήση των πληροφοριακών
              συστημάτων, αλλά και κατά την επικοινωνία σου με αποστολείς και
              παραλήπτες και λοιπούς εργαζόμενους, όπως αυτά είναι απαραίτητα
              στο πλαίσιο παροχής των υπηρεσιών SLM. Επίσης, τα δεδομένα σου
              γίνονται αντικείμενο επεξεργασίας και στο πλαίσιο της κατάθεσης
              των αντικαταβολών που εισέπραξες.
            </p>
            <p>
              Επίσης, στο πλαίσιο της εκπλήρωσης των συμβατικών δεσμεύσεών μας
              προς εσένα, πραγματοποιούμε αυτοματοποιημένη επεξεργασία ορισμένων
              δεδομένων σου για τον ακριβή υπολογισμό των επιπρόσθετων παροχών
              και επιβραβεύσεων/κινήτρων που θα λάβεις. Το αποτέλεσμα της
              αυτοματοποιημένης διαδικασίας αξιολόγησης από το οποίο προκύπτει
              και το ύψος της επιπρόσθετης παροχής συναρτάται από τον όγκο των
              παραγγελιών που διεκπεραίωσες σε συνάρτηση προς τον χρόνο που
              χρειάστηκε για κάθε συγκεκριμένη διαδρομή.
            </p>
          </div>
          <div class="bussiness-specs">
            <span><u>B. Νομοθεσία</u></span>
            <p class="p-align mt-3">
              Επίσης, αποτελεί καταρχήν έννομη υποχρέωση της SKR Staffing, αλλά
              κατά περίπτωση και της SLM, να επεξεργάζονται περαιτέρω τα
              προσωπικά σου δεδομένα, στο πλαίσιο εκπλήρωσης των υποχρεώσεών
              τους που απορρέουν από την ισχύουσα εργατική,
              κοινωνικοασφαλιστική, φορολογική και λοιπή νομοθεσία, όπως η
              καταβολή των ασφαλιστικών εισφορών σου και η διαχείριση τυχόν
              αιτημάτων που αφορούν στα προσωπικά σου δεδομένα.
            </p>
            <p>
              Ειδικότερα, εν όψει των υποχρεώσεων που επιβάλλονται από την
              εργατική και κοινωνικοασφαλιστική νομοθεσία, οι Εταιρίες
              επεξεργάζονται και ευαίσθητα προσωπικά δεδομένα σου (δεδομένα
              υγείας), στο πλαίσιο τυχόν αδειών ασθενείας, καθώς και στο πλαίσιο
              τυχόν επίσκεψής σου στο γιατρό εργασίας. Τα δεδομένα αυτά
              παραμένουν εμπιστευτικά και αποθηκεύονται με ασφάλεια!
            </p>
          </div>
          <div class="bussiness-specs">
            <span><u>Γ. Έννομο συμφέρον</u></span>
            <p class="p-align mt-3">
              Οι Εταιρίες έχουν έννομο συμφέρον να λαμβάνουν από εσένα στοιχεία
              επικοινωνίας έκτακτης ανάγκης κοντινών σου προσώπων, καθώς και
              πληροφορίες που αφορούν στην εμπειρία σου στις Εταιρίες κατά την
              αποχώρησή σου. Επιπλέον, είναι στο έννομο συμφέρον της SLM να
              επεξεργάζεται δεδομένα σου στο πλαίσιο πρόληψης κι αντιμετώπισης
              αστοχιών, περιστατικών ασφάλειας, κατάχρησης ή άλλης κακόβουλης
              χρήσης των πληροφοριακών συστημάτων και υπηρεσιών SLM, καθώς και
              να διενεργεί ελέγχους φυσικής ασφάλειας (χρήση συστήματος CCTV και
              καρτών πρόσβασης).
            </p>
          </div>
          <div class="bussiness-specs">
            <span><u>Δ. Νομικές Αξιώσεις</u></span>
            <p class="p-align mt-3">
              Σε ενημερώνουμε ότι σε κάθε περίπτωση, οι Εταιρίες διατηρούν το
              δικαίωμα να επεξεργάζονται τα προσωπικά σου δεδομένα και στο
              πλαίσιο τυχόν έγερσης ή υπεράσπισης νομικών αξιώσεών τους.
            </p>
          </div>
          <div class="bussiness-specs">
            <span><u>Ε. Συγκατάθεση</u></span>
            <p class="p-align mt-3">
              Στην περίπτωση που χρειαστεί να επεξεργαστούμε τα προσωπικά σου
              δεδομένα για σκοπούς άλλους από τους παραπάνω,
              <span class="strong">
                θα ζητήσουμε κάθε φορά την ειδικότερη συγκατάθεσή σου, την οποία
                μπορείς ελεύθερα να δώσεις ή και να αποσύρεις αργότερα, εφόσον
                το επιθυμείς.
              </span>
              Για παράδειγμα, εφόσον πρόκειται για κάποια εταιρική δράση, δράση
              κοινωνικής ευθύνης, δημοσίευση σε μέσα μαζικής ενημέρωσης ή social
              media, θα ζητήσουμε τη συγκατάθεσή σου, προτού κοινοποιήσουμε τα
              στοιχεία ή την εικόνα σου.
            </p>
          </div>
        </div>
        <div class="bussiness-specs">
          <h5>ΜΕ ΠΟΙΟΥΣ ΤΑ ΜΟΙΡΑΖΟΜΑΣΤΕ</h5>
          <div class="p-align mt-3">
            <p>
              Τα προσωπικά σου δεδομένα, συλλέγονται και γίνονται αντικείμενο
              περαιτέρω επεξεργασίας από ειδικά προς αυτό εξουσιοδοτημένο
              προσωπικό των Εταιριών.
            </p>
            <p>
              Στο πλαίσιο της καλύτερης διαχείρισης της Σχέσης αλλά και των
              λειτουργικών και οργανωτικών αναγκών των Εταιριών, και πάντοτε σε
              συμφωνία με την ισχύουσα νομοθεσία για την προστασία προσωπικών
              δεδομένων, αποδέκτες των προσωπικών σου δεδομένων μπορεί να είναι:
            </p>
            <ul>
              <li>
                Πάροχοι πληροφοριακών συστημάτων και τεχνολογικών λύσεων όπως η
                Epsilon, η Intercom, η Usign, η Mailchimp, η Northstar, η Xero,
                η UpKeep, η Microsoft και η Google. Στο πλαίσιο λειτουργίας
                ορισμένων εκ των εταιριών αυτών, τα δεδομένα σου ενδέχεται να
                διαβιβαστούν και εκτός Ευρωπαϊκού Χώρου και ιδίως στις ΗΠΑ,
                ωστόσο εφαρμόζονται σχετικά, αυξημένα μέτρα προστασίας, όπως
                ειδικές τυποποιημένες συμβατικές ρήτρες και τεχνική
                παραμετροποίηση,
              </li>
              <li>
                Εξωτερικοί δικηγόροι, σύμβουλοι, λογιστές, ελεγκτές, ο γιατρός
                εργασίας και λοιποί πάροχοι υπηρεσιών,
              </li>
              <li>
                Οι προμηθευτές εταιρικών παροχών, όπως η UP Hellas για τις
                προπληρωμένες κάρτες,
              </li>
              <li>
                Η Brinks, η οποία είναι διαθέτει την τεχνολογική υποδομή για την
                self-service κατάθεση των αντικαταβολών μέσω ειδικών μηχανημάτων
                και επιτηρεί την φυσική ασφάλεια της κεντρικής αποθήκης 
              </li>
              <li>Άλλες εταιρίες του Ομίλου Σκρουτζ.</li>
              <li>Εταιρίες που ανήκουν στον Όμιλο Σκρουτζ,</li>
              <li>
                καθώς και οποιαδήποτε άλλη διοικητική, δικαστική ή δημόσια αρχή
                ή γενικά νομικό ή φυσικό πρόσωπο προς το οποίο ενδέχεται βάσει
                νόμου ή δικαστικής απόφασης, να απορρέει σχετική υποχρέωση ή
                δικαίωμα των Εταιριών να ανακοινώνουν τέτοια δεδομένα.
              </li>
            </ul>
          </div>
        </div>
        <div class="bussiness-specs">
          <h5>ΠΟΣΟ ΚΑΙΡΟ ΤΑ ΔΙΑΤΗΡΟΥΜΕ</h5>
          <p class="p-align mt-3">
            Τα προσωπικά σου δεδομένα που συλλέγουμε στο πλαίσιο της Σχέσης θα
            διατηρούνται καθόλη τη διάρκεια αυτής και το αργότερο για 20 έτη
            μετά τη λήξη αυτής.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΣΟΥ</h5>
          <div class="p-align mt-3">
            <p>
              Εφόσον συντρέχουν οι προϋποθέσεις της νομοθεσίας και στο πλαίσιο
              της Σχέσης, έχεις και μπορείς να ασκήσεις τα ακόλουθα δικαιώματα:
            </p>
            <ul>
              <li>
                <span class="strong">το δικαίωμα πρόσβασης,</span> το δικαίωμα
                δηλαδή αφενός να ενημερωθείς για το κατά πόσον τα προσωπικά σου
                δεδομένα υφίστανται επεξεργασία και αφετέρου να λάβεις περαιτέρω
                πληροφορίες σχετικά με την πραγματοποιούμενη επεξεργασία,
              </li>
              <li>
                <span class="strong">το δικαίωμα να ζητήσετε τη διόρθωση</span>
                τυχόν ανακριβών προσωπικών σας δεδομένων ή τη συμπλήρωση αυτών,
              </li>
            </ul>
          </div>
          <p class="p-align mt-3 ml-4">
            καθώς και εφόσον συντρέχουν οι προϋποθέσεις της νομοθεσίας:
          </p>
          <div class="p-align mt-3">
            <ul>
              <li>
                <span class="strong">το δικαίωμα να εναντιωθείς</span> στην
                επεξεργασία των δεδομένων σου που βασίζεται στο έννομο συμφέρον
                των Εταιριών,
              </li>
              <li>
                <span class="strong">το δικαίωμα στη φορητότητα</span> των
                δεδομένων σου προς άλλον υπεύθυνο επεξεργασίας ή προς εσένα, σε
                κατάλληλο μορφότυπο,
              </li>
              <li><span class="strong">το δικαίωμα διαγραφής,</span></li>
              <li>
                <span class="strong">το δικαίωμα περιορισμού</span> της
                επεξεργασίας,
              </li>
              <li>
                <span class="strong">
                  το δικαίωμα να αποσύρεις τυχόν ειδική συγκατάθεσή
                </span>
                σου
              </li>
            </ul>
          </div>
          <p class="p-align mt-3">
            Σε περίπτωση άσκησης των δικαιωμάτων διόρθωσης, διαγραφής και
            περιορισμού των δεδομένων σου, τα αιτήματα αυτά θα διαβιβάζονται και
            στους τρίτους αποδέκτες στους οποίους τα δεδομένα αυτά τυχόν
            γνωστοποιήθηκαν από εμάς.
          </p>
          <p class="p-align mt-3">
            Μπορείς να ασκήσεις οποιοδήποτε από τα παραπάνω δικαιώματα,
            υποβάλλοντας έγγραφο αίτημα στον Υπεύθυνο Προστασίας Δεδομένων (Data
            Protection Officer) της SLM,
            <span class="strong">
              ως μόνο αρμόδιο κανάλι επικοινωνίας και για τις δύο
            </span>
            Εταιρίες. Μπορείς να αναμένεις απάντηση σε τέτοιο αίτημα εντός ενός
            (1) μήνα μετά τη λήψη του και σε κάθε περίπτωση, εντός δύο (2)
            επιπλέον μηνών, εφόσον αυτό επιβάλλεται από την πολυπλοκότητα του
            αιτήματος ή το γενικότερο αριθμό των ληφθέντων αιτημάτων.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ</h5>
          <p class="p-align mt-3">
            Για οποιαδήποτε απορία σχετικά την επεξεργασία των προσωπικών σου
            δεδομένων από τις Εταιρίες στο πλαίσιο της Σχέσης, καθώς και για την
            άσκηση των ανωτέρω δικαιωμάτων σου, παρακαλούμε να στείλεις e-mail
            στην ηλεκτρονική διεύθυνση
            <a href="mailto:dpo@skroutzdelivery.gr">dpo@skroutzdelivery.gr</a>.
          </p>
        </div>
        <div class="bussiness-specs">
          <h5>Δικαίωμα Καταγγελίας</h5>
          <p class="p-align mt-3">
            Σε περίπτωση που θεωρείς ότι δεν ικανοποιήσαμε επαρκώς το αίτημά σου
            και θίγεται κατά οποιονδήποτε τρόπο η προστασία των προσωπικών σου
            δεδομένων, μπορείς να υποβάλεις καταγγελία μέσω
            <a href="https://www.dpa.gr/el/syndesi/prosvasi">
              ειδικής διαδικτυακής πύλης
            </a>
            στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (Αθήνα, Λεωφόρος
            Κηφισίας 1-3, Τ.Κ. 115 23 | τηλ: +30 210 6475600). Αναλυτικές
            οδηγίες υποβολής καταγγελίας παρέχονται στην
            <a href="https://www.dpa.gr/el/polites/katagelia_stin_arxi">
              Ιστοσελίδα
            </a>
            της Αρχής.
          </p>
        </div>
      </div>
    </section>

    <page-footer />
  </div>
</template>

<script>
import PageFooter from '../components/PageFooter.vue';
import Navbar from '../components/Navbar.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    Navbar,
    PageFooter
  }
};
</script>

<style lang="scss" scoped>
section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: unset;
  border-radius: unset;
  padding: 32px 16px;

  h4,
  h6 {
    font-weight: bold;
    text-align: center;
  }
  h4 {
    line-height: 40px;
  }
}
.privacy-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  min-height: 600px;
  width: 100%;
  max-width: 780px;

  .p-align {
    text-align: justify;
  }
}

.bussiness-specs {
  margin-top: 1rem;

  h5 {
    font-weight: bold;
    font-size: 1.2em;
  }
  div {
    margin: 0.5rem 0;
  }
  ul {
    margin-left: 2rem;
    li {
      list-style-type: disc;
      margin-top: 12px;
      list-style-position: outside;

      &::before {
        content: '';
        display: inline-block;
      }
    }
  }
  .strong {
    font-weight: bold;
  }
}
</style>
